import './ExpCard.css';

function ExpCard(props) {
    return (
      <div className='exp-card'>
        <h3>{props.title}</h3>

        <span>{props.iconOne}</span>

        <p>{props.roleOne}</p>
        <p>{props.dateOne}</p>

        <span>{props.iconTwo}</span>

        <p>{props.roleTwo}</p>
        <p>{props.dateTwo}</p>
      </div>
    );
  }

export default ExpCard;